import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsCurrentItems from "./en-us/current-items.json";
import localizationEnUsRecommendedItems from "./en-us/recommended-items.json";
import localizationEnUsRequiredItems from "./en-us/required-items.json";
import localizationEnUsSubtotal from "./en-us/subtotal.json";
import localizationEnUsEmpty from "./en-us/empty.json";

export const localizationEnUsCart = {
  ...localizationEnUsHeader,
  ...localizationEnUsCurrentItems,
  ...localizationEnUsRecommendedItems,
  ...localizationEnUsRequiredItems,
  ...localizationEnUsSubtotal,
  ...localizationEnUsEmpty,
};
